<div class="ui-g-12">
  <div class="card card-w-title">
    <div style="display: flex; flex-wrap: wrap">
      <div style="flex-shrink: 1; white-space: nowrap">
        <h1>Search Result</h1>
      </div>
    </div>

    <p-table
      #dataTable
      selectionMode="single"
      *ngIf="isLoaded; else loading"
      [value]="transactions"
      [responsive]="true"
      resizableColumns="true"
      (onRowSelect)="showDetails()"
      [(selection)]="selectedTransaction"
      styleClass="data-table-compact"
      sortField="createdOn"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="transactionNumber">Transaction Number</th>
          <th pSortableColumn="organisation.name">Organisation</th>
          <th pSortableColumn="createdOn">Created On</th>
          <th>Xero Code</th>
          <th>Transaction Type</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>{{ item.transactionNumber }}</td>
          <td>{{ item.organisation.Name }}</td>
          <td>
            <span>{{ item.createdOn | datex : 'ddd DD MMM YYYY' }}</span>
          </td>
          <td>
            <span>{{ item.description.description }}({{ item.description.xeroCode }})</span>
          </td>
          <td>{{ item.transactionLinePrefix.type }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!--- DATATABLE DEPRECATED ---
      <p-dataTabl #dataTable selectionMode="single"
                   *ngIf="isLoaded; else loading"
                   [value]="transactions"
                   [responsive]="true"
                   resizableColumns="true"
                   (onRowSelect)="showDetails(selectedTransaction)"
                   [(selection)]="selectedTransaction"
                   styleClass="data-table-compact" sortField="createdOn">
        <p-column field="transactionNumber" header="Transaction Number" [sortable]="tru" [editable]="false"
                  [style]="{'width': '10%'}" styleClass="text-center"></p-column>
        <p-column field="organisation.name" header="Organisation" [sortable]="tru" [editable]="false"
                  [style]="{'width': '8.5em'}" styleClass="text-center"></p-column>
        <p-column field="createdOn" header="Created On" [sortable]="tru" [editable]="false"
                  [style]="{'width': '10%'}" styleClass="text-center">
                  <ng-template let-col let-item="rowData" pTemplate="body">
                    <span>{{ item.createdOn| datex:'ddd DD MMM YYYY'}}</span>
                  </ng-template>
                </p-column>
        <p-column header="description.xeroCode" header="Xero Code" [sortable]="tru" [editable]="false" [style]="{'width': '8em'}" styleClass="text-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            <span>{{item.description.description}}({{item.description.xeroCode}})</span>
          </ng-template>
        </p-column>
        <p-column field="transactionLinePrefix.type" header="Transaction Type" [sortable]="tru" [editable]="false"
                  [style]="{'width': '6.5em'}" styleClass="text-center"></p-column>
      </p-dataTable>
      --->

    <ng-template #loading>Loading...</ng-template>
    <div class="footerPanel ui-grid-row">
      <button
        label="Transaction Details"
        [disabled]="!selectedTransaction"
        class="btn-to-right"
        (click)="showDetails()"
        pButton
      ></button>
    </div>
  </div>
</div>

<div *ngIf="selectedTransaction">
  <div class="ui-g-12">
    <div class="ui-g-4">
      <div class="card card-w-title">
        <h3>Selected Transaction Detail</h3>
        <div class="ui-g no-padding">
          <div class="ui-g-4"><b>Transaction Number</b></div>
          <div class="ui-g-8">{{ selectedTransaction.transactionNumber }}</div>
          <div class="ui-g-4"><b>Created On</b></div>
          <div class="ui-g-8">{{ selectedTransaction.createdOn | datex : 'ddd DD MMM YYYY' }}</div>
          <div class="ui-g-4"><b>Invoiced</b></div>
          <div class="ui-g-8">{{ selectedTransaction.isInvoiced ? 'Yes' : 'No' }}</div>
          <div class="ui-g-4"><b>VAT Included</b></div>
          <div class="ui-g-8">{{ selectedTransaction.description.includeVAT ? 'Yes' : 'No' }}</div>
          <div class="ui-g-4"><b>Prefix Description</b></div>
          <div class="ui-g-8">{{ selectedTransaction.transactionLinePrefix.description }}</div>
          <div class="ui-g-4"><b>Custom Description</b></div>
          <div class="ui-g-8">{{ selectedTransaction.customDescription }}</div>
        </div>
      </div>
    </div>
    <div class="ui-g-8" *ngIf="transactionHistoryTimeline">
      <div class="card card-w-title">
        <h3>Selected Transaction History</h3>
        <timeline
          [items]="transactionHistoryTimeline"
          [iconMapping]="{ time: 'icon-clock1_666' }"
          emptyMessage="No history to display"
        ></timeline>
      </div>
    </div>
  </div>
</div>
